import { render, staticRenderFns } from "./ProgressBars.vue?vue&type=template&id=3ea50288"
import script from "./ProgressBars.vue?vue&type=script&lang=js"
export * from "./ProgressBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea50288')) {
      api.createRecord('3ea50288', component.options)
    } else {
      api.reload('3ea50288', component.options)
    }
    module.hot.accept("./ProgressBars.vue?vue&type=template&id=3ea50288", function () {
      api.rerender('3ea50288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/progress-bars/ProgressBars.vue"
export default component.exports